module.exports = __webpack_public_path__ + "static/puffins-357d38d378d2c1df273c86467215a8e6.jpg";